import LocalizedStrings from 'localized-strings';

export const locales = new LocalizedStrings({
  en: {
    callouts: {
      canceled: {
        description: 'Contact the account holder for more information.',
        title: 'Canceled expense claim',
      },
      pending: {
        description:
          'The request for reimbursement is currently being examined by the account holder.',
        title: 'Pending approval',
      },
      processing: {
        description:
          'The expense claim has been validated by the account holder. It is now being processed, which can take up to 24 hours.',
        title: 'Processing',
      },
    },
  },
  fr: {
    callouts: {
      canceled: {
        description:
          'Contactez le ou la titulaire du compte pour plus d’informations.',
        title: 'Note de frais annulée',
      },
      pending: {
        description:
          'La demande de remboursement est en cours d’examen par le ou la titulaire du compte.',
        title: 'En attente de validation',
      },
      processing: {
        description:
          'La demande de remboursement a bien été validée par le ou la titulaire du compte. Elle est maintenant en traitement, ce qui peut prendre jusqu’à 24h.',
        title: 'En cours de traitement',
      },
    },
  },
} as const);
